"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray")),
    _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _reactFiles = _interopRequireDefault(require("react-files")),
    _lodash = _interopRequireDefault(require("lodash.flatten"));

require("../styles/_files.scss");

var MIN_FILE_SIZE = 0,
    FILE_SIZE_MULTIPLIER = 1e10,
    MAX_FILE_SIZE_GB = 10 * FILE_SIZE_MULTIPLIER,
    fileExtensions = {
  image: ["image/*"],
  video: ["video/*"],
  audio: ["audio/*"],
  document: [".pdf", ".doc", ".docx"]
},
    allFileTypes = Object.keys(fileExtensions);

function containsItems(array) {
  return array && 0 < array.length;
}

function showIllegalTypeError(illegalType) {
  throw new Error("\"".concat(illegalType, "\" is not an allowed type for Files, please use one of ").concat(JSON.stringify(allFileTypes)));
}

function getExtensionsList(allowedTypes) {
  var types = containsItems(allowedTypes) ? allowedTypes : allFileTypes,
      allowedTypesArray = types.map(function (type) {
    return fileExtensions[type];
  });
  return (0, _lodash["default"])(allowedTypesArray);
}

function handleDragDrop(setIsVisible, _ref) {
  var visible = _ref.visible;
  return function (e) {
    e.preventDefault(), setIsVisible(visible);
  };
}

function Files(_ref2) {
  var _ref2$clickable = _ref2.clickable,
      _ref2$multiple = _ref2.multiple,
      _ref2$maxFileSize = _ref2.maxFileSize,
      maxFileSize = void 0 === _ref2$maxFileSize ? MAX_FILE_SIZE_GB : _ref2$maxFileSize,
      _ref2$minFileSize = _ref2.minFileSize,
      minFileSize = void 0 === _ref2$minFileSize ? MIN_FILE_SIZE : _ref2$minFileSize,
      _ref2$dragStyling = _ref2.dragStyling,
      dragStyling = void 0 !== _ref2$dragStyling && _ref2$dragStyling,
      onFilesChange = _ref2.onFilesChange,
      onFilesError = _ref2.onFilesError,
      allowedTypes = _ref2.allowedTypes,
      handleRef = _ref2.handleRef,
      className = _ref2.className,
      children = _ref2.children,
      _useState = (0, _react.useState)(!1),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isVisible = _useState2[0],
      setIsVisible = _useState2[1],
      illegalType = containsItems(allowedTypes) && allowedTypes.find(function (type) {
    return !fileExtensions[type];
  });

  illegalType && showIllegalTypeError(illegalType);
  var dragEvents = dragStyling ? {
    onDrop: handleDragDrop(setIsVisible, {
      visible: !1
    }),
    onDragLeave: handleDragDrop(setIsVisible, {
      visible: !1
    }),
    onDragEnter: handleDragDrop(setIsVisible, {
      visible: !0
    })
  } : {};
  return _react["default"].createElement("div", dragEvents, _react["default"].createElement(_reactFiles["default"], {
    className: (0, _classnames["default"])(className, "drop-files", {
      "drop-files--active": isVisible && dragStyling
    }),
    clickable: !(void 0 !== _ref2$clickable) || _ref2$clickable,
    multiple: void 0 !== _ref2$multiple && _ref2$multiple,
    maxFileSize: maxFileSize,
    minFileSize: minFileSize,
    onChange: onFilesChange,
    onError: onFilesError,
    accepts: getExtensionsList(allowedTypes),
    ref: handleRef
  }, isVisible && dragStyling ? _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("p", null, _react["default"].createElement("strong", null, "Drag & Drop")), _react["default"].createElement("p", null, _react["default"].createElement("small", null, "For ease of use, drop your file(s) into here"))) : children));
}

var _default = (0, _react.memo)(Files);

exports["default"] = _default;